import { Link } from "react-router-dom";
import { BarChart3, UsersRound, Tractor, Sprout, CircleDollarSign, PackageOpen, ClipboardCheck, FileCheck2, Archive, Users } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const reportLinks = [
  { label: "Dashboard Summary", to: "/dashboard", icon: BarChart3, description: "Management KPI overview with geography and date filters" },
  { label: "Farmer Registry", to: "/farmers", icon: UsersRound, description: "Registered farmers, status, geographic distribution" },
  { label: "Farms", to: "/farms", icon: Tractor, description: "Farm records with Plot acreage, crop establishment and mapping" },
  { label: "Harvest & Aggregation", to: "/harvest", icon: Sprout, description: "Physical coffee deliveries and aggregation records" },
  { label: "Commercial & Payments", to: "/commercial", icon: CircleDollarSign, description: "60/40 commercial transactions, farmer payments, outstanding balances" },
  { label: "Inventory & Stock", to: "/inventory", icon: PackageOpen, description: "Stock balances, movements, input distributions" },
  { label: "Field Visits", to: "/visits", icon: ClipboardCheck, description: "Field visit activity, offline/online origin, follow-ups" },
  { label: "Agreements", to: "/agreements", icon: FileCheck2, description: "60/40 agreement status, expiry, amendments" },
  { label: "Assets", to: "/assets", icon: Archive, description: "Asset register, assignments, maintenance" },
  { label: "Staff & Users", to: "/staff", icon: Users, description: "Staff directory, project assignments" },
];

export default function ReportsPage() {
  return (
    <div className="space-y-6" data-testid="reports-page">
      <PageHeader
        eyebrow="Management reporting"
        title="Reports"
        description="Management reporting layer. All reports use validated source-of-truth data and respect project-level authorization."
      />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="report-links-grid">
        {reportLinks.map((report) => {
          const Icon = report.icon;
          return (
            <Link key={report.to} to={report.to} data-testid={`report-link-${report.to.replace("/", "")}`}>
              <Card className="transition-colors hover:border-primary/40 hover:bg-secondary/30">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-base">
                    <Icon className="size-5 text-primary" />
                    {report.label}
                  </CardTitle>
                  <CardDescription className="text-sm">{report.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <span className="inline-flex items-center text-sm text-primary">Open report →</span>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
